// extracted by mini-css-extract-plugin
export default {"box":"EZGoz_A00FGropVM_aqb"};